import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-song-suggestion-page',
  templateUrl: './song-suggestion-page.component.html',
  styleUrls: ['./song-suggestion-page.component.scss']
})
export class SongSuggestionPageComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
